import React from 'react';

import {
	BoxRef,
	ColorPaletteThemeModel,
	PopperRef,
	TooltipRef,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';

interface IconTooltipHelperOutput {
	colorPalette: ColorPaletteThemeModel;
	anchorIconTooltipRef: React.RefObject<BoxRef>;
	tooltipIconTooltipRef: React.RefObject<PopperRef>;
}

export const useIconTooltipHelper = (): IconTooltipHelperOutput => {
	const { colorPalette } = useTheme();

	const anchorIconTooltipRef = React.useRef<BoxRef>(null);
	const tooltipIconTooltipRef = React.useRef<TooltipRef>(null);

	return { colorPalette, anchorIconTooltipRef, tooltipIconTooltipRef };
};
